import { render, staticRenderFns } from "./erick.vue?vue&type=template&id=7ecf22e1&scoped=true"
var script = {}
import style0 from "./erick.vue?vue&type=style&index=0&id=7ecf22e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf22e1",
  null
  
)

export default component.exports